module.exports = __webpack_public_path__ + "static/media/pessocial1.13ea738f.png";